import { useState, useEffect } from "react";
import { getActiveSubscription } from "../services/subscriptionHistoryService";
import { getOrganizationId } from "../utils/organizationUtils";

/**
 * Loads GST % from hospital onboarding / active subscription.
 * No configured GST (removed, never set, includeGST disabled) means 0% — a
 * missing/null value must NOT be treated as "use the old default of 18".
 */
export const useOrganizationGstPercentage = (user, { enabled = true } = {}) => {
  const [gstPercentage, setGstPercentage] = useState(0);

  useEffect(() => {
    if (!enabled) return;

    let cancelled = false;
    const fetchGst = async () => {
      try {
        const organizationId = getOrganizationId(user);
        if (organizationId) {
          const activeSubscription = await getActiveSubscription(organizationId);
          if (!cancelled) {
            if (
              activeSubscription?.includeGST !== false &&
              activeSubscription?.gstPercentage != null
            ) {
              setGstPercentage(Number(activeSubscription.gstPercentage));
            } else {
              setGstPercentage(0);
            }
          }
        } else if (!cancelled) {
          setGstPercentage(0);
        }
      } catch (error) {
        console.error("Error fetching GST percentage:", error);
        if (!cancelled) setGstPercentage(0);
      }
    };

    fetchGst();
    return () => {
      cancelled = true;
    };
  }, [user, enabled]);

  return gstPercentage;
};

export default useOrganizationGstPercentage;
